import { Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {

  constructor(
  
  ) { }

  loadScriptClarity() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `(function(c,l,a,r,i,t,y){ c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)}; t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i; y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y); })(window, document, "clarity", "script", "pxdn8wv4bk");`;
    
    document.head.appendChild(script)
  }
  loadScriptCookieBot(){
    let script:any = document.createElement('script'); 

    script.id = 'Cookiebot'
    script.src = 'https://consent.cookiebot.com/uc.js'; 
    script.type = 'text/javascript'; 
    script.async = true; 
    script.dataset.cbid = "bb0d601e-f391-4331-aee8-dc7e51d1538b";
    script.dataset.blockingmode = "auto";
    
    document.head.appendChild(script)
  }
  
  loadScriptCookieDeclaration(){
    let script = document.createElement('script'); 

    script.id = 'CookieDeclaration'
    script.src = 'https://consent.cookiebot.com/bb0d601e-f391-4331-aee8-dc7e51d1538b/cd.js'; 
    script.type = 'text/javascript'; 
    script.async = true; 
    
    document.head.appendChild(script); 
  }
}
